import styled from '@emotion/styled'

import { useTheme } from '@emotion/react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import NavigationV2 from '@segment/templates/Navigation2'
import GettingStarted from '@segment/templates/GettingStarted'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import LogoCarousel from './components/LogoCarousel'
import Testimonial from './components/Testimonial'
import Video from './components/Video'

import MakeItAContinuousConversation from './components/MakeItAContinuousConversation'
import OrchestrateTheOutcomes from './components/OrchestrateTheOutcomes'
import UnitePaidAndOwnedChannels from './components/UnitePaidAndOwnedChannels'
import Testimonials from './components/Testimonials'
import ChooseYourOwnJourney from './components/ChooseYourOwnJourney'
import FaqSection from './components/FaqSection'
import BuildDeeper from './components/BuildDeeper'

import ogImagePng from './assets/OgJourneys.png'

const JourneysView = () => {
  const theme = useTheme()
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Journeys: Customer Journey Management Software | Twilio Segment"
        pageDescription="Journeys from Twilio Segment is a complete customer journey management tool, allowing you to orchestrate omnichannel customer engagement."
        pageOG={ogImagePng}
        bodyBackground={theme.palette.neutrals.white[100]}
      >
        <NavigationV2 />
        <Hero />
        <Main>
          <LogoCarousel />
          <Testimonial />
          <Video />
          <MakeItAContinuousConversation />
          <OrchestrateTheOutcomes />
          <BuildDeeper />
          <UnitePaidAndOwnedChannels />
          <Testimonials />
          <ChooseYourOwnJourney />
          <FaqSection />
          <GettingStarted />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default JourneysView
